import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const partnerChoiceForm = (props) => {
  const buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="from_age"
            config={props.inputs.from_age}
            changed={event => props.inputChangedHandler(event, 'from_age')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="to_age"
            config={props.inputs.to_age}
            changed={event => props.inputChangedHandler(event, 'to_age')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="from_height"
            config={props.inputs.from_height}
            changed={event => props.inputChangedHandler(event, 'from_height')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="to_height"
            config={props.inputs.to_height}
            changed={event => props.inputChangedHandler(event, 'to_height')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="marital_status"
            config={props.inputs.marital_status}
            changed={event => props.inputChangedHandler(event, 'marital_status')}
            loadOptions={asyncSelectData.getMaritalStatusOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="caste"
            config={props.inputs.caste}
            changed={event => props.inputChangedHandler(event, 'caste')}
            loadOptions={asyncSelectData.getCasteOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="qualification"
            config={props.inputs.qualification}
            changed={event => props.inputChangedHandler(event, 'qualification')}
            loadOptions={() => asyncSelectData.getOptionConstants('qualification')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="degree"
            config={props.inputs.degree}
            changed={event => props.inputChangedHandler(event, 'degree')}
            loadOptions={asyncSelectData.getDegrees}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="profession"
            config={props.inputs.profession}
            changed={event => props.inputChangedHandler(event, 'profession')}
            loadOptions={() => asyncSelectData.getOptionConstants('profession')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="work_profile"
            config={props.inputs.work_profile}
            changed={event => props.inputChangedHandler(event, 'work_profile')}
            loadOptions={asyncSelectData.getWorkProfile}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="income"
            config={props.inputs.income}
            changed={event => props.inputChangedHandler(event, 'income')}
            loadOptions={asyncSelectData.getIncome}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="country"
            config={props.inputs.country}
            changed={event => props.inputChangedHandler(event, 'country')}
            loadOptions={asyncSelectData.getCountryOptions}
          />
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <InputField
            id="diet"
            config={props.inputs.diet}
            changed={event => props.inputChangedHandler(event, 'diet')}
            loadOptions={() => asyncSelectData.getOptionConstants('diet')}
          />
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <InputField
            id="smoke"
            config={props.inputs.smoke}
            changed={event => props.inputChangedHandler(event, 'smoke')}
            loadOptions={() => asyncSelectData.getOptionConstants('smoke')}
          />
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <InputField
            id="drink"
            config={props.inputs.drink}
            changed={event => props.inputChangedHandler(event, 'drink')}
            loadOptions={() => asyncSelectData.getOptionConstants('drink')}
          />
        </Grid>
        <Grid item md={6} xs={6} sm={6}>
          <InputField
            id="horoscope"
            config={props.inputs.horoscope}
            changed={event => props.inputChangedHandler(event, 'horoscope')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default partnerChoiceForm;



// WEBPACK FOOTER //
// ./src/profile/components/PartnerChoiceForm.js